import { render, staticRenderFns } from "./PatientBills.vue?vue&type=template&id=186bcaac&"
import script from "./PatientBills.vue?vue&type=script&lang=js&"
export * from "./PatientBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports